<template>
  <div class="login-wrap">
    <div class="wrap">
      <div class="left">
        <img src="../../assets/bg1.png" class="bg1">
      </div>
      <div class="right">
        <div class="logo">
          <img src="../../assets/cue@2x.png">
        </div>
        <div class="title">业务数据管理平台</div>
        <a-form
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item
            class="username"
          >
            <a-input
              size="large"
              v-decorator="[
          'username',
          {rules: [{ required: true, message: '请输入用户名!' }]}
        ]"
              placeholder="用户名"
            >
              <a-icon slot="prefix" type="user"/>
            </a-input>
          </a-form-item>
          <a-form-item
            class="password"
          >
            <a-input
              size="large"
              v-decorator="[
          'userpwd',
          {rules: [{ required: true, message: '请输入密码!' }]}
        ]"
              placeholder="密码"
              type="password"
            >
              <a-icon slot="prefix" type="lock"/>
            </a-input>
          </a-form-item>
          <div style="display: flex;justify-content: space-between">
            <div class="remember">
              <a-checkbox :checked="rememberPwd"
                          @change="handleCheck">
                <span class="des">记住密码</span>
              </a-checkbox>
            </div>
            <div class="modifyPwd">
<!--              <a :href=url>忘记密码？</a>-->
            </div>
          </div>
          <a-form-item
            class="login"
          >
            <a-button
              type="primary"
              html-type="submit"
              class="submitBtn"
              @click="handleSubmit"
            >
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../../api'
import _ from 'lodash'
import storage from 'good-storage'

export default {
  name: 'login',
  data () {
    return {
      rememberPwd: false,
      loginInfo: storage.get('loginInfo'),
      form: this.$form.createForm(this)
    }
  },
  created () {
    this.rememberPwd = !_.isEmpty(this.loginInfo)
  },
  mounted () {
    if (this.rememberPwd) {
      this.form.setFieldsValue({
        'username': this.loginInfo.username,
        'userpwd': this.loginInfo.userpwd
      })
    }
  },
  methods: {
    handleCheck (e) {
      this.rememberPwd = e.target.checked
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(
        (err, val) => {
          if (!err) {
            val.pid = 26
            // debugger
            login(val).then((res) => { // 登陆成功相应的改动才能生效
              const { customers, usertoken, uid } = res
              const { username } = val
              if(customers.length>0){
                // token方面
                this.$store.commit('change_token', usertoken)
                // 账户密码，记住密码
                if (this.rememberPwd) {
                  storage.set('loginInfo', val)
                } else {
                  storage.remove('loginInfo')
                }
                // 用户信息
                this.$store.commit('change_loginUser', {
                  name: username,
                  utoken: usertoken,
                  uid: uid,
                  clientList: customers,
                  client: {}
                })
                // this.$router.push('/chooseClient')
                this.$store.commit('change_loginUser', { client: customers[0] })
                this.$router.push('/batch')
              }else{
                this.$message.warning('没有权限，请联系管理员')
              }
            })
          }
        }
      )
    }
  }
}
</script>
<style lang='less'>
  @import '../../common/styles/varibles.less';
  @import '../../common/styles/mixins.less';

  .login-wrap {
    width: 100%;
    min-width: 960px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("../../assets/background.png");
    background-position: center;
    background-size: contain;
    background-attachment: fixed;

    /deep/ .ant-form-item-control-wrapper { //兼容safari
      width: 105%;
    }

    .wrap {
      font-family: @pm;
      display: flex;
      height: 406px;

      .left {
        font-size: 0;

        img {
          width: 406px;

        }

        .des {
          position: absolute;
          z-index: 10;
          font-size: 56px;
        }
      }

      .right {
        width: 368px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 93px;

        .logo {
          img {
            width: 120px;
          }
        }

        .title {
          font-family: @pr;
          font-size: 18px;
          line-height: 36px;
          color: #242424;
        }

        /deep/ .ant-form-item-children {
          position: static;
        }

        /deep/ .ant-form-item-control {
          position: static;
        }

        /deep/ .ant-form {
          width: 100%;
          margin-top: 40px;

          .username, .password {
            display: flex;
            align-items: center;
            justify-content: center;
            /*margin-bottom: 24px;*/
          }

          .password {
            /*margin-bottom: 20px;*/
          }

          .remember {
            margin-bottom: 20px;

            .des {
              margin-left: 3px;
              color: rgba(0, 0, 0, 0.65);
              font-family: @pr;
            }
          }

          .modifyPwd {
            color: @default;
            cursor: pointer;
          }

          .login {
            /*width: 352px;*/
            display: flex;
            justify-content: center;
            align-items: center;

            .submitBtn {
              width: 352px;
              border-color: @defaultBlue;

              &:after {
                border-color: @defaultBlue;
              }
            }

            /deep/ .ant-btn {
              width: 370px;
              height: 40px;
              background-color: #414042;
            }
          }
        }
      }
    }
  }
</style>
